import { defineRouting } from 'next-intl/routing';
import { MESSAGES_MAP } from './constants';

export const routing = defineRouting({
  locales: Object.keys(MESSAGES_MAP),
  defaultLocale: MESSAGES_MAP.ru,
  localePrefix: 'always',
});
